<div *ngIf="label && showLabelOnMobile" class="dropdown-label">
  <p class="input-label-name font-size-14 fw-600">
    {{ label }}
  </p>
</div>
<div class="date-range-filter">
  <div class="option-dropdown">
    <lib-single-option-dropdown
      [optionList]="dateRangeFilterList"
      [placeholder]="placeholder"
      [label]="isMobile ? 'Dates' : ''"
      [(ngModel)]="selectedOption"
      (changeEvent)="onOptionSelect(selectedOption)"
    />
  </div>
  <div *ngIf="showCustomPicker" class="custom-date-input">
    <lib-date-input
      [selectionMode]="
        selectedOption === dateRangeFilterEnum.BETWEEN ? 'range' : 'single'
      "
      [placeholder]="placeholder"
      [minDate]="minDate"
      [formControls]="formControls"
      [showPlaceholderIcon]="true"
      [iconPositionAtEnd]="true"
      [(ngModel)]="displayValue"
      (changeEvent)="onCustomDateSelection($event)"
    />
  </div>
</div>
